import { render, staticRenderFns } from "./ContactWidget.vue?vue&type=template&id=2cff875d"
import script from "./ContactWidget.vue?vue&type=script&lang=ts"
export * from "./ContactWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports